export default "__VITE_ASSET__Bx9go1OS__"